import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const CLIENT_API_URL = process.env.REACT_APP_API_URL + "/api/client/";

const getMobileDevices = (clientId, page = 0, size = 50) => {
  return axios.get(
    `${CLIENT_API_URL}${clientId}/mobiles?page=${page}&size=${size}`,
    { headers: authHeader() }
  );
};

const batchDeleteMobileDevices = (clientId, deviceIds) => {
  return axios.delete(
    `${CLIENT_API_URL}${clientId}/mobiles/batch-delete`,
    {
      headers: authHeader(),
      data: deviceIds
    }
  );
};

const mobileDeviceService = {
  getMobileDevices,
  batchDeleteMobileDevices
};

export default mobileDeviceService;


